import gs1Instance from '../api-index'

const { get, put, } = gs1Instance

const getAllNotificationByUser = async (params) => {
  const response = await get(`/gs1/standard/user/notifications`, params)
  return response.data;
}


const clearAllNotificationByUser = async () => {
    const response = await put(`/gs1/standard/user/notifications/clear`)
    return response.data;
}


export { getAllNotificationByUser, clearAllNotificationByUser };
